var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-service-container"
  }, [_c('div', {
    staticClass: "container text-center color-ccc fs-30 empty-tip "
  }, [_vm._v("\n      暂无更多\n    ")]), _vm._v(" "), _vm._l((_vm.contactList), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "service-item"
    })
  })], 2)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-948ba696","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/exhibitor/components/homeService.vue
// module id = null
// module chunks = 